import { CloudDownloadOutlined, SendOutlined } from '@ant-design/icons'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { Modal, Popconfirm, Radio } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'

export function ExtraImageModal({ isVisible, onCancel, onOk, fields = [] }) {
  const photoFields = useMemo(() => fields?.filter((f) => f.type === 'photo'), [fields])
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0)
  useEffect(() => setSelectedPhotoIndex(0), [photoFields])
  const containerStyle = {
    height: 'calc(100vh - 400px)',
  }

  return (
    <Modal
      title={photoFields[0]?.name}
      visible={isVisible}
      width='60vw'
      style={{ width: '60vw' }}
      bodyStyle={{ overflowY: 'scroll' }}
      onCancel={onCancel}
      onOk={onOk}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <a href={photoFields?.[0]?.payload?.url} download>
            <GraviButton icon={<CloudDownloadOutlined />} onClick={() => {}} buttonText='Download' theme2 />
          </a>
        </div>
      }
    >
      {photoFields.length > 1 && (
        <Radio.Group
          className='mb-4'
          value={selectedPhotoIndex}
          onChange={(e) => setSelectedPhotoIndex(e.target.value)}
        >
          {photoFields?.map((field, i) => (
            <Radio.Button value={i}>{field.name}</Radio.Button>
          ))}
        </Radio.Group>
      )}
      <img
        className='mt-4'
        src={photoFields?.[selectedPhotoIndex]?.payload?.url}
        style={{ width: '100%', height: '100%' }}
      />
    </Modal>
  )
}
